import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CONSTANTS } from '../constants/constants';
import { Observable } from 'rxjs';
import { Group } from '../types/event-response.type';

@Injectable({
  providedIn: 'root',
})
export class GroupsHttpService {
  constructor(private http: HttpClient) {}

  getGroups(categoryId: number): Observable<{ groups: Group[] }> {
    return this.http.get<{ groups: Group[] }>(
      `${CONSTANTS.BASE_API}groups?category_id=${categoryId}`
    );
  }
}
